import React from "react";
import { FaGithub, FaLinkedin, FaWhatsapp, FaEnvelope } from "react-icons/fa";

const FooterSection = ({ language }) => {
  // Traducciones para español e inglés
  const translations = {
    es: {
      thanks: "Gracias por visitar mi portafolio",
      description:
        "Este portafolio muestra mi experiencia y habilidades como desarrollador. Si te interesa trabajar conmigo o tienes algún proyecto en mente, ¡contáctame!",
      rights: "Casi todos los derechos reservados.",
    },
    en: {
      thanks: "Thank you for visiting my portfolio",
      description:
        "This portfolio showcases my experience and skills as a developer. If you're interested in working with me or have a project in mind, feel free to contact me!",
      rights: "Almost all rights reserved.",
    },
  };

  // Selección de traducciones según el idioma
  const t = translations[language] || translations.es;

  const socialLinks = [
    { icon: <FaGithub />, link: "https://github.com/Julianpril", label: "GitHub" },
    { icon: <FaLinkedin />, link: "http://www.linkedin.com/in/julian-abril", label: "LinkedIn" },
    { icon: <FaWhatsapp />, link: "https://wa.me/+573204397001", label: "Whatsapp" },
    { icon: <FaEnvelope />, link: "mailto:julianpril1482@gmail.com", label: "Email" },
  ];

  return (
    <footer className="bg-gray-900 text-white py-6">
      <div className="container mx-auto px-4 flex flex-col items-center">
        <h3 className="text-2xl text-center font-jersey mb-4">{t.thanks}</h3>
        <p className="font-paragraph font-semibold text-center text-gray-400 mb-6">
          {t.description}
        </p>
        <div className="flex space-x-6 mb-6">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-teal-500 text-2xl transition duration-300"
              aria-label={social.label}
            >
              {social.icon}
            </a>
          ))}
        </div>
        <div className="border-t border-gray-700 w-full pt-4">
          <p className="text-gray-500 text-sm text-center">
            © {new Date().getFullYear()} Julián Abril Herrera. {t.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
